import { Scissors } from "lucide-react";
import { SpecialtyPage } from "@/components/SpecialtyPage";

export default function HairRestoration() {
  return (
    <SpecialtyPage
      icon={Scissors}
      titleKey="specialties.hair.title"
      subtitleKey="specialties.hair.subtitle"
      overviewKey="specialties.hair.overview"
      procedures={[
        { nameKey: "specialties.hair.procedure1Name", descriptionKey: "specialties.hair.procedure1Desc", durationKey: "specialties.hair.procedure1Duration", recoveryKey: "specialties.hair.procedure1Recovery" },
        { nameKey: "specialties.hair.procedure2Name", descriptionKey: "specialties.hair.procedure2Desc", durationKey: "specialties.hair.procedure2Duration", recoveryKey: "specialties.hair.procedure2Recovery" },
        { nameKey: "specialties.hair.procedure3Name", descriptionKey: "specialties.hair.procedure3Desc", durationKey: "specialties.hair.procedure3Duration", recoveryKey: "specialties.hair.procedure3Recovery" },
      ]}
      advantagesKeys={["specialties.hair.advantage1", "specialties.hair.advantage2", "specialties.hair.advantage3"]}
      faq={[
        { questionKey: "specialties.hair.faq1Q", answerKey: "specialties.hair.faq1A" },
        { questionKey: "specialties.hair.faq2Q", answerKey: "specialties.hair.faq2A" },
        { questionKey: "specialties.hair.faq3Q", answerKey: "specialties.hair.faq3A" },
        { questionKey: "specialties.hair.faq4Q", answerKey: "specialties.hair.faq4A" },
        { questionKey: "specialties.hair.faq5Q", answerKey: "specialties.hair.faq5A" },
      ]}
      priceFromKey="specialties.hair.priceFrom"
      priceNoteKey="specialties.hair.priceNote"
      comparisonKey="specialties.hair.comparison"
      ctaTitleKey="specialties.hair.ctaTitle"
    />
  );
}
